
export const validateFieldPure = (field, value) => {

    const emailRegex = new RegExp("^(?!\\.)(?!.*\\.\\.)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~.-]+(?<!\\.)@[a-zA-Z0-9-]+(?:\\.[a-zA-Z]{2,})+$");
    const indianMobileRegex = '^[6-9]\\d{9}$';
    const amountRegex = new RegExp('^(\\d{1,3})(,\\d{2})*(\\.\\d{1,2})?$|^\\d+(\\.\\d{1,2})?$');
    const customerNameRegex = new RegExp('^[A-Za-z]+(?: [A-Za-z]+)*$');

    if (!field) return { isValid: true, error: '' };

    if (field.required && (!value || (Array.isArray(value) && value.length === 0))) {
        return { isValid: false, error: field.errorMessage || 'This field is required' };
    }

   

    let options = {};
    try {
        if (field.options) {
            options = typeof field.options === 'string' ? JSON.parse(field.options) : field.options;
        }
    } catch (e) {
        console.warn(`Invalid JSON in options for field "${field.name}"`, e);
    }

    // Regex check
    if (options.regex && typeof value === 'string' && value) {
        if (!new RegExp(options.regex).test(value)) {
            return { isValid: false, error: options.regexErrMsg || field.errorMessage || 'Invalid format' };
        }
        // If custom regex passed, skip default validations
        return { isValid: true, error: '' };
    }

    // Min length
    if (typeof options.minLength === 'number' && typeof value === 'string' && value.length < options.minLength) {
        if (!field.required && value.length === 0) return { isValid: true, error: '' };
        return { isValid: false, error: options.regexErrMsg || `Minimum ${options.minLength} characters required.` };
    }

    // Max length
    if (typeof options.maxLength === 'number' && typeof value === 'string' && value.length > options.maxLength) {
        return { isValid: false, error: options.regexErrMsg || `Maximum ${options.maxLength} characters allowed.` };
    }

     // Set defualt validation on email name and mobile number if no regex provided.
    //  Priority is to test first regex provided if not than do the defualt one

    if(field.mappedBy !== undefined || field.mappedBy !==null)
    {
        if(field.mappedBy === "customer.email" && !emailRegex.test(value))
        {
            console.log("defualt email validation")
            return { isValid: false, error: 'Invalid email Format' };
        }
        if(field.mappedBy === "customer.phone" && !new RegExp(indianMobileRegex).test(value))
        {
            console.log("defualt email validation")
            return { isValid: false, error: 'Invalid Mobile Number' };
        }

        if(field.mappedBy === "amount" && !amountRegex.test(value))
        {
        
            return { isValid: false, error: 'Invalid Amount' };
        }
        if(field.mappedBy === "customer.name" && !customerNameRegex.test(value) )
        {
        
            return { isValid: false, error: 'Only Alphabets are allowed' };
        }

    }

    return { isValid: true, error: '' };
};
